export type TodoEntityType = 'relation' | 'project' | 'quote' | 'order'

export interface TodoRelationRef {
  id: string
  name: string
}

export interface TodoNumberedRef {
  id: string
  number: string | null
}

export class Todo {
  constructor(
    public readonly id: string,
    public readonly userId: string,
    public readonly text: string,
    public readonly isDone: boolean,
    public readonly relationId: string | null,
    public readonly projectId: string | null,
    public readonly quoteId: string | null,
    public readonly orderId: string | null,
    public readonly relation: TodoRelationRef | null,
    public readonly project: TodoNumberedRef | null,
    public readonly quote: TodoNumberedRef | null,
    public readonly order: TodoNumberedRef | null,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
  ) {
  }

  static fromJson(json: any): Todo {
    return new Todo(
      json['id'],
      json['user_id'],
      json['text'],
      json['is_done'],
      json['relation_id'] ?? null,
      json['project_id'] ?? null,
      json['quote_id'] ?? null,
      json['order_id'] ?? null,
      json['relation'] ? {id: json['relation']['id'], name: json['relation']['name']} : null,
      json['project'] ? {id: json['project']['id'], number: json['project']['number'] ?? null} : null,
      json['quote'] ? {id: json['quote']['id'], number: json['quote']['number'] ?? null} : null,
      json['order'] ? {id: json['order']['id'], number: json['order']['number'] ?? null} : null,
      new Date(json['created_at']),
      new Date(json['updated_at']),
    );
  }
}
